var _rect, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333008,
    width: 23,
    height: 23,
    rx: 4,
    fill: "#8800C7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M18.3013 6.22879H5.36475L5.84391 16.65H17.8222L18.3013 6.22879Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M18.3013 6.22879H5.36475L11.3238 10.6755H12.4319L18.3013 6.22879Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M6.44226 16.6503L11.8329 11.7987L17.2235 16.6503H6.44226Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.44301 7.1274C6.44301 6.63149 6.04125 6.22902 5.54462 6.22902C5.04872 6.22902 4.64624 6.63149 4.64624 7.1274C4.64624 9.04059 4.64624 13.5102 4.64624 15.5722C4.64624 16.168 5.12921 16.6502 5.7243 16.6502C6.10665 16.6502 6.44301 16.6502 6.44301 16.6502C6.44301 16.6502 6.44301 9.65652 6.44301 7.1274Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2233 7.12717C17.2233 6.63126 17.6257 6.22879 18.1216 6.22879C18.1223 6.22879 18.1231 6.22879 18.1231 6.22879C18.619 6.22879 19.02 6.63055 19.02 7.12573C19.02 9.0382 19.02 13.5093 19.02 15.5719C19.02 16.1677 18.5378 16.65 17.942 16.65C17.5603 16.65 17.2233 16.65 17.2233 16.65C17.2233 16.65 17.2233 9.65629 17.2233 7.12717Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.09448 7.90526C4.88822 7.78596 4.73801 7.59047 4.6762 7.36049C4.61439 7.13051 4.64673 6.88616 4.76604 6.6799C4.76604 6.6799 4.76676 6.67918 4.76676 6.67846C4.88606 6.4722 5.08226 6.32199 5.31225 6.26018C5.54223 6.19838 5.78731 6.23072 5.99357 6.35002L11.833 9.72138L17.6739 6.3493C17.8801 6.23 18.1245 6.19766 18.3545 6.25947C18.5845 6.32127 18.7799 6.47148 18.8993 6.67774L18.9 6.67846C19.0193 6.88472 19.0516 7.13051 18.9898 7.36049C18.928 7.59047 18.7771 7.78668 18.5708 7.90598L13.6298 10.7584L11.833 11.7962L10.0363 10.7584L5.09448 7.90526Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/Gmail.a5c8ca33.svg";
export { ForwardRef as ReactComponent };